import React, { Component } from "react";
import styled from "styled-components";
import Header from "../Component/Header";
import Contents from "../Component/Contents";
import Buttons from "../Component/Buttons";
import Cont from "../Component/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faQuestion
} from "@fortawesome/free-solid-svg-icons";
import ExamplePic from "../Img/Example.png";

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="fadeIn">
        <Cont className="container">
          <Header
            title={ExamplePic}
            desc="아래 형식으로 주장의 예시를 써주세요!"
            stage="1"
          ></Header>
          <Contents stage="example" placeholder="예를 들어.."></Contents>
          <Buttons
            array={[
              [<FontAwesomeIcon icon={faArrowLeft} />, "/reason"],
              ["info", "실제로 난 양배추를 챙겨 먹고 만성 위염에서 벗어났다."],
              [<FontAwesomeIcon icon={faArrowRight} />, "/offer"]
            ]}
          ></Buttons>
        </Cont>
        {/* <Footer stage="4"></Footer> */}
      </div>
    );
  }
}

export default Example;
